import React from 'react';
import { compose } from 'ramda';
import { SlideContext } from './slideContext';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from '../Slide/slide';
import SlideMulti from './slideMulti';
import SlideMultiWrapper from './SlideMultiWrapper';
import { withSlide } from '../../providers/slideProvider';

const Slide = class Slide extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      position: 0,
      slides: [],
      
      visibleItems: props.config.visibleItems || 1,
      snapToLastElement: props.config.snapToLastElement || false,
      customTransition: props.config.customTransition || null,
      transitionDuration: props.config.transitionDuration || '500',
      autoPlay: props.config.autoPlay || false,
      autoPlaySpeed: props.config.autoPlaySpeed || 5000,
      touchDraggable: props.config.touchDraggable !== false,
      cursorDraggable: props.config.cursorDraggable !== false,
      itemsGap: props.config.itemsGap || 0,
    };

    this.group = props.config.group || null;
    this.handler = new SlideMulti({ setState: this.setState.bind(this), getState: () => this.state  })
    this.props.config.subscribe(this);
  }



  handleResize = () => {
    this.setState(state => {
      return {
        visibleItems: this.props.config.visibleItems || 1,
        snapToLastElement: this.props.config.snapToLastElement || false,
        customTransition: this.props.config.customTransition || null,
        transitionDuration: this.props.config.transitionDuration || '500',
        autoPlay: this.props.config.autoPlay || false,
        autoPlaySpeed: this.props.config.autoPlaySpeed || 5000,
        touchDraggable: this.props.config.touchDraggable !== false,
        cursorDraggable: this.props.config.cursorDraggable !== false,
        itemsGap: this.props.config.itemsGap || 0,
      };
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }
  
  subscribeSlide = (slide) => {
    this.setState(state => {
      return {
        slides: [...state.slides, slide]
      };
    });
  }
  
  next = () => {
    this.props.config.next(this.group)
  }

  prev = () => {
    this.props.config.prev(this.group)
  }

  goTo = (position) => {
    this.props.config.goTo(this.group,position)
  }
  
  render() {
    
    return (
      <React.Fragment>
        <SlideContext.Provider
          value={{
            // items
            position: this.state.position,
            subscribeSlide: this.subscribeSlide,
            slides: this.state.slides,
            
            // animation
            visibleItems: this.state.visibleItems,
            snapToLastElement: this.state.snapToLastElement,
            customTransition: this.state.customTransition,
            transitionDuration: this.state.transitionDuration,
            autoPlay: this.state.autoPlay,
            autoPlaySpeed: this.state.autoPlaySpeed,
            touchDraggable: this.state.touchDraggable,
            cursorDraggable: this.state.cursorDraggable,
            itemsGap: this.state.itemsGap,
            
            // actions
            next: this.next,
            prev: this.prev,
            goTo: this.goTo,
          }}>
          
          {this.props.children}
          <SlideMultiWrapper/>
        </SlideContext.Provider>
      </React.Fragment>
    );
  }
};

export default compose(
  withSlide,
  PropertyManager([
    'children',
    'propagateSelectedKey',
    'selectionMode',
    'group',
    'subscribe',
    'next',
    'prev',
    'goTo',

    'visibleItems',
    'snapToLastElement',
    'customTransition',
    'transitionDuration',
    'autoPlay',
    'autoPlaySpeed',
    'touchDraggable',
    'cursorDraggable',
    'itemsGap'
  ]),
  withThemeJSS({ styleFile, displayName: 'Slide' }),
)(Slide);
